export default __webpack_public_path__ + "static/media/features-1.d109dfe2.jpg";